// Curated Sri Lanka destinations
// Each destination uses a unique, verified Unsplash photo from Sri Lanka collections.
const u = (id) =>
  `https://images.unsplash.com/photo-${id}?fm=jpg&q=85&w=1200&auto=format&fit=crop&ixlib=rb-4.1.0`;

export const CATEGORIES = [
  "All",
  "Heritage",
  "Beach",
  "Wildlife",
  "Nature",
  "Culture",
  "City",
];

export const destinations = [
  // ---------- Heritage / Ancient Cities ----------
  {
    place_id: "sigiriya-lion-rock",
    name: "Sigiriya Lion Rock",
    location: "Dambulla",
    category: "Heritage",
    rating: 4.9,
    image: u("1711797750174-c3750dd9d7c9"),
    description:
      "Iconic 5th-century rock fortress with frescoes, mirror wall and lion-paw gateway.",
    popular: true,
  },
  {
    place_id: "dambulla-cave-temple",
    name: "Dambulla Cave Temple",
    location: "Dambulla",
    category: "Heritage",
    rating: 4.7,
    image: u("1756670164679-83f5fa92d1e1"),
    description:
      "UNESCO golden cave temple with 153 Buddha statues across five caves.",
  },
  {
    place_id: "anuradhapura",
    name: "Anuradhapura",
    location: "North Central",
    category: "Heritage",
    rating: 4.7,
    image:
      "https://customer-assets.emergentagent.com/job_f64483f2-2916-4f5a-aecc-f84ed5193a19/artifacts/dsbo70oh_130697682.d08ZkYNo.jpg",
    description:
      "First capital of Sri Lanka — sacred Bo tree, Ruwanwelisaya and ancient stupas.",
  },
  {
    place_id: "jetawanaramaya",
    name: "Jetawanaramaya Stupa",
    location: "Anuradhapura",
    category: "Heritage",
    rating: 4.6,
    image: u("1690099229071-e5a7d8de8781"),
    description:
      "Once the tallest brick structure in the ancient world, towering 122m.",
  },
  {
    place_id: "polonnaruwa",
    name: "Polonnaruwa",
    location: "North Central",
    category: "Heritage",
    rating: 4.7,
    image:
      "https://customer-assets.emergentagent.com/job_f64483f2-2916-4f5a-aecc-f84ed5193a19/artifacts/5uz06czm_polos.png",
    description:
      "Medieval royal city with Gal Vihara rock-carved Buddhas and ancient palaces.",
  },
  {
    place_id: "galle-fort",
    name: "Galle Fort",
    location: "Galle",
    category: "Heritage",
    rating: 4.8,
    image: u("1743615132653-d6bfc6f8fac6"),
    description:
      "Dutch colonial fort with cobbled streets, ramparts and ocean views.",
    popular: true,
  },
  {
    place_id: "temple-of-the-tooth-kandy",
    name: "Temple of the Tooth",
    location: "Kandy",
    category: "Culture",
    rating: 4.8,
    image: u("1737008233497-e68685c8142f"),
    description: "UNESCO temple housing the sacred tooth relic of the Buddha.",
    popular: true,
  },
  {
    place_id: "jaffna",
    name: "Jaffna",
    location: "Northern",
    category: "Culture",
    rating: 4.6,
    image:
      "https://customer-assets.emergentagent.com/job_f64483f2-2916-4f5a-aecc-f84ed5193a19/artifacts/hpa1446k_Jaffana.png",
    description:
      "Vibrant Tamil heartland — Nallur Kovil, fort, islands and unique cuisine.",
  },

  // ---------- Wildlife ----------
  {
    place_id: "yala",
    name: "Yala National Park",
    location: "Southern",
    category: "Wildlife",
    rating: 4.8,
    image:
      "https://customer-assets-jt897jd0.emergentagent.net/job_f64483f2-2916-4f5a-aecc-f84ed5193a19/artifacts/tt4h48u6_images.jpg",
    description:
      "Safari haven with the world's highest leopard density, plus elephants and crocs.",
    popular: true,
  },
  {
    place_id: "udawalawe",
    name: "Udawalawe National Park",
    location: "Sabaragamuwa",
    category: "Wildlife",
    rating: 4.7,
    image:
      "https://customer-assets.emergentagent.com/job_f64483f2-2916-4f5a-aecc-f84ed5193a19/artifacts/fapltsnd_udawalawe-park%20%281%29.jpg",
    description:
      "Reliable elephant sightings and the Elephant Transit Home.",
  },
  {
    place_id: "wilpattu",
    name: "Wilpattu National Park",
    location: "North Western",
    category: "Wildlife",
    rating: 4.6,
    image:
      "https://customer-assets.emergentagent.com/job_f64483f2-2916-4f5a-aecc-f84ed5193a19/artifacts/ixf5s5f2_Wilpattu%20National%20Park.png",
    description:
      "Sri Lanka's largest park — leopards, sloth bears and tranquil natural lakes.",
  },
  {
    place_id: "kumana",
    name: "Kumana National Park",
    location: "Eastern",
    category: "Wildlife",
    rating: 4.5,
    image:
      "https://customer-assets.emergentagent.com/job_f64483f2-2916-4f5a-aecc-f84ed5193a19/artifacts/wmpea3yf_Kumana%20National%20Park.png",
    description:
      "Bird-watcher's paradise with mangroves and a famous wading-bird sanctuary.",
  },
  {
    place_id: "habarana",
    name: "Habarana",
    location: "North Central",
    category: "Wildlife",
    rating: 4.6,
    image:
      "https://customer-assets.emergentagent.com/job_f64483f2-2916-4f5a-aecc-f84ed5193a19/artifacts/2pfz7akr_habrana.png",
    description:
      "Gateway to Minneriya / Hurulu — witness 'The Gathering' of wild elephants.",
  },
  // ---------- Beach / Coast ----------
  {
    place_id: "mirissa-beach",
    name: "Mirissa Beach",
    location: "Mirissa",
    category: "Beach",
    rating: 4.7,
    image: u("1594169051945-43bf3c79616e"),
    description: "Whale watching capital with a crescent palm-fringed beach.",
    popular: true,
  },
  {
    place_id: "weligama",
    name: "Weligama",
    location: "Southern",
    category: "Beach",
    rating: 4.6,
    image: u("1519566335946-e6f65f0f4fdf"),
    description: "Beginner-friendly surf bay with the iconic stilt fishermen.",
  },
  {
    place_id: "ahangama",
    name: "Ahangama",
    location: "Southern",
    category: "Beach",
    rating: 4.6,
    image: u("1646894232861-a0ad84f1ad5d"),
    description: "Boho surf town with reef breaks and palm-shaded cafés.",
  },
  {
    place_id: "hikkaduwa",
    name: "Hikkaduwa",
    location: "Southern",
    category: "Beach",
    rating: 4.5,
    image: u("1561150018-8bb356679537"),
    description: "Coral reef snorkeling, sea turtles and a lively beach scene.",
  },
  {
    place_id: "hiriketiya",
    name: "Hiriketiya",
    location: "Southern",
    category: "Beach",
    rating: 4.7,
    image: u("1531201890865-fb64780d16e9"),
    description: "Horseshoe-shaped surf cove tucked behind a coconut grove.",
  },
  {
    place_id: "unawatuna",
    name: "Unawatuna",
    location: "Galle",
    category: "Beach",
    rating: 4.6,
    image: u("1525849306000-cc26ceb5c1d7"),
    description: "Calm bay perfect for swimming, snorkeling and sunset cocktails.",
  },
  {
    place_id: "bentota",
    name: "Bentota",
    location: "Western",
    category: "Beach",
    rating: 4.6,
    image: u("1552055569-d54ae89a11b7"),
    description: "Long golden beach plus river safaris through Madu lagoon.",
  },
  {
    place_id: "tangalle",
    name: "Tangalle",
    location: "Southern",
    category: "Beach",
    rating: 4.6,
    image: u("1507525428034-b723cf961d3e"),
    description: "Wild stretches of empty sand and turtle nesting beaches.",
  },
  {
    place_id: "tissamaharama",
    name: "Tissamaharama (Tissa)",
    location: "Southern",
    category: "Wildlife",
    rating: 4.5,
    image:
      "https://customer-assets.emergentagent.com/job_f64483f2-2916-4f5a-aecc-f84ed5193a19/artifacts/1qk5oxdy_Tissamaharama.png",
    description: "Lake-side base for Yala safaris, with ancient stupas of its own.",
  },
  {
    place_id: "arugam-bay",
    name: "Arugam Bay",
    location: "Eastern",
    category: "Beach",
    rating: 4.8,
    image: u("1613693699413-7dde0260f437"),
    description:
      "World-class right-hand point break — Sri Lanka's surfing mecca.",
  },
  {
    place_id: "pasikuda",
    name: "Pasikuda",
    location: "Eastern",
    category: "Beach",
    rating: 4.6,
    image: u("1653959747793-c7c3775665f0"),
    description: "Shallow turquoise lagoon — wade out hundreds of meters at low tide.",
  },
  {
    place_id: "batticaloa",
    name: "Batticaloa",
    location: "Eastern",
    category: "City",
    rating: 4.4,
    image: u("1552055568-f8c4fb8c6320"),
    description: "Lagoon city of 'singing fish', Dutch fort and Tamil culture.",
  },
  {
    place_id: "trincomalee",
    name: "Trincomalee",
    location: "Eastern",
    category: "Beach",
    rating: 4.7,
    image:
      "https://customer-assets.emergentagent.com/job_f64483f2-2916-4f5a-aecc-f84ed5193a19/artifacts/6cmsaxd8_Trincomalee.png",
    description:
      "Pristine Nilaveli & Uppuveli beaches plus deep harbour and Koneswaram temple.",
  },
  {
    place_id: "negombo",
    name: "Negombo",
    location: "Western",
    category: "Beach",
    rating: 4.4,
    image:
      "https://imgs.search.brave.com/_9Kl0pJTLbDG-NnSaD6bhzCLmAmxQVsQHuJ4R4ELa9M/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly93d3cu/dG91cnNsYW5rYS5j/b20vd3AtY29udGVu/dC91cGxvYWRzLzIw/MTgvMDUvTmVnb21i/bzEuanBn",
    description: "Lagoon fishing town near the airport — perfect first or last stop.",
  },
  {
    place_id: "colombo",
    name: "Colombo",
    location: "Western",
    category: "City",
    rating: 4.5,
    image:
      "https://imgs.search.brave.com/Zb9uaWJC6JUP7KZVaidn2MiZLGbKUcit2m88kbAQM50/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pbWFn/ZXMudW5zcGxhc2gu/Y29tL3Bob3RvLTE3/MDQ3OTczOTA3Njct/ZGUzZTYzZmE5Mzlm/P2ZtPWpwZyZxPTYw/Jnc9MzAwMCZpeGxp/Yj1yYi00LjEuMCZp/eGlkPU0zd3hNakEz/ZkRCOE1IeHpaV0Z5/WTJoOE5IeDhZMjlz/YjIxaWIzeGxibnd3/Zkh3d2ZIeDhNQT09",
    description:
      "The buzzing capital — Galle Face, Pettah markets, rooftop bars and shopping.",
  },

  // ---------- Mountain / Hill Country ----------
  {
    place_id: "nine-arches-bridge",
    name: "Nine Arches Bridge",
    location: "Ella",
    category: "Nature",
    rating: 4.8,
    image: u("1574611122955-5baa61496637"),
    description: "Photogenic colonial railway bridge through tea-clad jungle hills.",
    popular: true,
  },
  {
    place_id: "tea-plantations-nuwara-eliya",
    name: "Tea Plantations",
    location: "Nuwara Eliya",
    category: "Nature",
    rating: 4.9,
    image: u("1586511623600-cb6f44f647d8"),
    description:
      "'Little England' of misty hills, lakes and emerald tea estates.",
    popular: true,
  },
  {
    place_id: "adams-peak",
    name: "Adam's Peak (Sri Pada)",
    location: "Central",
    category: "Nature",
    rating: 4.9,
    image:
      "https://customer-assets.emergentagent.com/job_f64483f2-2916-4f5a-aecc-f84ed5193a19/artifacts/zgeqedt1_Adam%27s%20Peak.png",
    description: "Sacred 2,243m pilgrim climb at night to catch a magical sunrise.",
  },
  {
    place_id: "hatton",
    name: "Hatton",
    location: "Central",
    category: "Nature",
    rating: 4.5,
    image: u("1566296314736-6eaac1ca0cb9"),
    description:
      "High-altitude tea-country town — base for Adam's Peak and scenic trains.",
  },
  {
    place_id: "horton-plains",
    name: "Horton Plains & World's End",
    location: "Central",
    category: "Nature",
    rating: 4.8,
    image:
      "https://customer-assets.emergentagent.com/job_f64483f2-2916-4f5a-aecc-f84ed5193a19/artifacts/pby1xt6v_horton-plains.png",
    description:
      "Misty plateau hike to a 870m sheer cliff drop and Baker's Falls.",
  },
  {
    place_id: "ambuluwawa",
    name: "Ambuluwawa Tower",
    location: "Gampola",
    category: "Nature",
    rating: 4.6,
    image:
      "https://customer-assets.emergentagent.com/job_f64483f2-2916-4f5a-aecc-f84ed5193a19/artifacts/m67a7nq1_Ambuluwawa-Tower.jpg",
    description: "Spiraling multi-religious tower with 360° views over the hills.",
  },
  {
    place_id: "deniyaya-sinharaja",
    name: "Deniyaya & Sinharaja",
    location: "Southern",
    category: "Nature",
    rating: 4.7,
    image:
      "https://customer-assets.emergentagent.com/job_f64483f2-2916-4f5a-aecc-f84ed5193a19/artifacts/ktbpbkc3_anagimala-water-.jpg",
    description:
      "Gateway to UNESCO Sinharaja rainforest — endemic birds, leeches and waterfalls.",
  },
];

export const popularDestinations = destinations.filter((d) => d.popular);
